import { BasicPermissionItem } from '../../PermissionItem'
import { Simple } from '../../common'
import { ProjectSettings } from '../../../cimsPage/instances/admin'

const object = 'Project Settings'
const plural = 'project settings'
const page = ProjectSettings

export const EditProjectSettings = new BasicPermissionItem({
  id: 'aca30f63-ba78-48e1-8902-56e4d4632326',
  page,
  name: `Edit ${object}`,
  action: `edit general ${plural}`,
})

export const ViewProjectSettings = Simple({
  id: '495214c1-072c-40b5-ad8a-68c71d11cd7c',
  page,
  object,
  plural,
  action: 'View',
})

export const EditSharePointSettings = new BasicPermissionItem({
  id: '8b7e7f2f-4770-45c6-99e4-598fcd62295c',
  page,
  name: 'Edit SharePoint Settings',
  action: 'edit SharePoint connection settings',
  allowMixedCase: true,
})

export const EditWorkflowSettings = new BasicPermissionItem({
  id: '879d203f-1b47-443f-8d07-1c532bec7af5',
  page,
  name: 'Edit Workflow Settings',
  action: 'edit workflow settings',
})

export type SettingsPermission =
  | typeof EditProjectSettings
  | typeof ViewProjectSettings
  | typeof EditSharePointSettings
  | typeof EditWorkflowSettings
